// routeBus
// ========
//
// Wave 14ds: Singleton-Bus für die aktuell ausgewählte Route-Geometrie.
//
// Motivation: das Battery-Safe-Mode-Overlay (PocketModeOverlay) sitzt global
// in App.tsx, AUSSERHALB von MapPage. Es will aber die geplante Route der
// gerade gefolgten Tour/Trail/Custom-Tour in seiner Mini-Map ("Briefmarke")
// zeichnen. Die Route-Geometrie lebt sonst nur in MapPage-lokalem State
// (`selected`). Statt diesen State über mehrere Ebenen durchzureichen,
// publisht MapPage die Geometrie hier rein; Konsumenten subscriben.
//
// Shape: ein flaches `[lat, lon]`-Array (oder null wenn nichts selektiert /
// freier Ride ohne geplante Route). Bewusst KEINE [lon, lat]-Reihenfolge wie
// GeoJSON — der Bus-Konsument (Canvas-Projektion) denkt in lat/lon, das passt
// zu GeolocationCoordinates aus dem positionBus.
//
// Kein React-State: MapPage schreibt aus einem useEffect, das Overlay liest
// React-extern + via useSyncExternalStore-Hook. Analog positionBus.

export type RoutePoint = [number, number, number?]; // [lat, lon, ele?]

export type Listener = (route: RoutePoint[] | null) => void;

class RouteBus {
  private current: RoutePoint[] | null = null;
  private readonly listeners = new Set<Listener>();

  get(): RoutePoint[] | null {
    return this.current;
  }

  set(route: RoutePoint[] | null): void {
    // Leeres Array wie null behandeln — ein 0-Punkte-"Route" ist kein Inhalt.
    this.current = route && route.length > 0 ? route : null;
    for (const l of this.listeners) l(this.current);
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const routeBus = new RouteBus();
